module.exports = "/images/img2.png?ef0801d1bb6a828760a2af57c7b6499c";